import { type InputHTMLAttributes, useId } from 'react';
import { cn } from '@/lib/utils';

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  unit?: string;
}

export function InputField({ label, error, unit, className, id, ...props }: InputFieldProps) {
  const reactId = useId();
  const inputId = id || reactId;

  return (
    <div className={cn("flex flex-col gap-1.5 w-full", className)}>
      <label htmlFor={inputId} className="text-sm font-medium text-slate-700">
        {label}
      </label>
      <div className="relative flex items-center">
        <input
          id={inputId}
          className={cn(
            "w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-slate-900 min-h-12 shadow-sm focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20 outline-none transition-all",
            unit && "pr-12",
            error && "border-red-500 focus:border-red-500 focus:ring-red-500/20"
          )}
          {...props}
        />
        {unit && (
          <span className="absolute right-4 text-slate-400 font-medium select-none pointer-events-none">
            {unit}
          </span>
        )}
      </div>
      {error && <span className="text-xs text-red-500 mt-1">{error}</span>}
    </div>
  );
}
